import { NavLink, useNavigate, useLocation } from "react-router-dom";
import {
  LayoutDashboard,
  UserRound,
  Users,
  DollarSign,
  Banknote,
  Undo2,
  Settings,
  LogOut,
} from "lucide-react";
import styles from "../../style/admin.module.css";
import { useAuthStore } from "../../hooks/useAuthStore";
import { useAppConfigContext } from "../../context/AppConfigContext";

const menuItems = [
  { icon: LayoutDashboard, label: "Dashboard", path: "/admin" },
  { icon: UserRound, label: "Pulo Assistant", path: "/admin/assistants" },
  { icon: Users, label: "Users", path: "/admin/users" },
  { icon: DollarSign, label: "Finances", path: "/admin/finances" },
  { icon: Banknote, label: "Withdrawals", path: "/admin/withdrawals" },
  { icon: Undo2, label: "Refunds", path: "/admin/refunds" },
  { icon: Settings, label: "Settings", path: "/admin/settings" },
];

function AdminSidebar({ isOpen, onClose }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { actions } = useAuthStore();
  const { config } = useAppConfigContext();

  const handleLogout = async () => {
    await actions.logout();
    navigate("/auth/admin/login");
  };

  return (
    <>
      {/* Mobile Overlay */}
      {isOpen && <div className={styles.overlay} onClick={onClose} />}
      
      <aside className={`${styles.sidebar} ${isOpen ? styles.sidebarOpen : ""}`}>
        <div className="mb-10 mt-4 flex items-center gap-2 px-6">
            <img src={config.logoUrl || "/logo192.png"} alt={config.appName || "PULO"} className="h-8 w-auto"/>
        </div>
        <nav className={styles.sidebarNav}>
          <ul className={styles.navList}>
            {menuItems.map((item) => {
              const Icon = item.icon;
              const isDashboard = item.path === "/admin";
              const isPuloAssistant = item.path === "/admin/assistants";
              const isAccommodations = item.path === "/admin/accommodations";
              const isRides = item.path === "/admin/rides";
              const isUsers = item.path === "/admin/users";
              const isFinances = item.path === "/admin/finances";
              const isWithdrawals = item.path === "/admin/withdrawals";
              const isRefunds = item.path === "/admin/refunds";
              // Check if current location matches the item path
              const isActive = location.pathname === item.path ||
                (item.path !== "/admin" && location.pathname.startsWith(item.path));
              const shouldHaveButtonStyle = isDashboard || isPuloAssistant || isAccommodations || isRides || isUsers || isFinances || isWithdrawals || isRefunds;
              return (
                <li key={item.path} className={styles.navItem}>
                  <NavLink
                    to={item.path}
                    end={item.path === "/admin"}
                    className={() => {
                      let classes = styles.navLink;
                      if (shouldHaveButtonStyle) {
                        classes += ` ${styles.dashboardLink}`;
                      }
                      if (isActive) {
                        classes += ` ${styles.navLinkActive}`;
                      }
                      return classes;
                    }}
                    onClick={onClose}
                  >
                    <Icon 
                      className={styles.navIcon} 
                      strokeWidth={isActive && shouldHaveButtonStyle ? 2.5 : 1.5}
                      fill={isActive && shouldHaveButtonStyle ? "currentColor" : "none"}
                    />
                    <span className={styles.navLabel}>{item.label}</span>
                  </NavLink>
                </li>
              );
            })}
          </ul>
        </nav>

        <div className={styles.sidebarFooter}>
          <button onClick={handleLogout} className={styles.logoutButton}>
            <LogOut className={styles.logoutIcon} />
            <span className={styles.logoutLabel}>Logout</span>
          </button>
        </div>
      </aside>
    </>
  );
}

export default AdminSidebar;
